import React from 'react'
import { Spinner } from '../../../../funcs/utils'
import PotentialDisclaimer from '../../../PotentialDashboard/PotentialDisclaimer/PotentialDisclaimer'
import { POTENTIAL_REPORT_DISCLAIMER_TEXT } from '../../../../constants/constants'

const process_line = (line, index) => {
  if (line.length === 0) {
    return (<div key={index} style={{height: "1rem"}}/>);
  }

  const h1_match = line.match(/^## (.+)$/m);
  if (h1_match) {
    const style = {
      fontSize: "2rem",
    }
    return (<div style={style} key={index}>{h1_match[1]}</div>);
  }

  const h2_match = line.match(/^### (.+)$/m);
  if (h2_match) {
    const style = {
      fontSize: "1.5rem",
    }
    return (<div style={style} key={index}>{h2_match[1]}</div>);
  }

  return (<div key={index}>{line}</div>);
}

const render_text = text => {

  // Remove any text found inside <think> tags
  const think_re = /<think>.*?<\/think>/gs;
  text = text.replace(think_re, '');

  const lines = text.split("\n");

  return (
    <div style={{ whiteSpace: "pre-line", margin: "16px 0" }}>
      { lines.map((line, index) => process_line(line, index)) }
    </div>
  )

}
const PotentialReport = ({ text, isLoading, isError }) => {
    if(isError) {
        return (
            <div>
                Oops! Looks like something went wrong. Please try again later.
            </div>
        )
    }

    if(isLoading) {
        return (
            <div style={{display: 'flex', justifyContent: 'center'}}>
                <Spinner size={"2rem"} />
            </div> 
        )
    }

    return (
      <React.Fragment>
        { render_text(text) }
        <PotentialDisclaimer text={POTENTIAL_REPORT_DISCLAIMER_TEXT} />
      </React.Fragment>
    )
}

export default PotentialReport